export default "__VITE_PUBLIC_ASSET__aa471e58__"